// src/components/tab/TabContent.js

import React from "react";
 
const TabContent = ({id, activeTab, children}) => {
 return (
   activeTab === id ? <div className="w-full">
     {children}
   </div>
   : null
 );
};
 
export default TabContent;